// Package imports:
import React, { useState } from 'react';
// import ReCAPTCHA from 'react-google-recaptcha';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
// Component imports:
import Input from '../../../ui-elements/Input/Formik/Input';
import DropSelect from '../../../ui-elements/DropSelect/DropSelect';
import Button from '../../../ui-elements/Button/Button';
import Alert from '../../../ui-elements/Alert/Alert';
// Service imports:
import { GET_KELDAN_API_URL } from '../../../services/config';
import { ErrorMessages } from '../../../services/errorMessages';
// Type imports:
import { IKeldanApiContact } from '../../../types/KeldanTypes';
import { Fetched } from '../../../types/Types';

interface IFormProps {
    values: IFormValues
}
interface IFormValues {
    name: string,
    email: string,
    message: string,
    // captcha: string
}
const REASON_OPT1 = 'Ég vil fá aðgang að KYC kerfi Hluthafaskrár';
const REASON_OPT2 = 'Ég vil fá PEP vefþjónustu';


const DueDiligenceForm: React.FC = () => {
    const [contactResponse, setContactResponse] = useState<Fetched<string>>(null);
    const [loading, setLoading] = useState<boolean>(false)
    const [reason, setReason] = useState<string>(REASON_OPT1)

    const handleSubmit = async (values: IFormValues, actions: any) => {
        setLoading(true)
        try {
            setContactResponse(null);
            const requestQuery = new URLSearchParams({
                name: values.name,
                email: values.email,
                subject: reason,
                message: values.message
            });
            const url = `${GET_KELDAN_API_URL()}/Home/DueDiligenceContactForm`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: requestQuery
            });
            if (response.ok) {
                const responseBody: IKeldanApiContact = await response.json();
                if (responseBody.success) {
                    setLoading(false)
                    setContactResponse(responseBody?.message || 'Fyrirspurn móttekin.');
                } else {
                    const { errors, message } = responseBody;
                    if (errors && errors.length > 0) {
                        setContactResponse(new Error(errors.join('\n')));
                    } else if (message) {
                        setContactResponse(new Error(message));
                    } else {
                        setContactResponse(new Error(ErrorMessages.ErrorInRequest));
                    }
                }
            } else {
                setLoading(false);
                setContactResponse(new Error(ErrorMessages.RequestFailed));
            }
        } catch (e) {
            setLoading(false);
            setContactResponse(new Error(ErrorMessages.NetworkError));
        }
    }


    const form: React.FC<IFormProps> = ({
        values
    }) => {
        return <Form>
                <div className="form__body">
                    <div className="form__row">
                        <div className="form__col">
                            <Input
                                label="Nafn"
                                name="name"
                                id="name"
                                value={values.name}
                            />
                        </div>
                        <div className="form__col">
                            <Input
                                label="Netfang"
                                name="email"
                                id="email"
                                value={values.email}
                            />
                        </div>
                    </div>
                    <div className="form__row">
                        <div className="form__col">
                            <DropSelect
                                options={[{
                                    label: REASON_OPT1,
                                    value: REASON_OPT1
                                }, {
                                    label: REASON_OPT2,
                                    value: REASON_OPT2
                                }]}
                                onChange={(e) => {
                                    if (typeof e === 'string') setReason(e)
                                }}
                                defaultValue={reason}
                                size='lg'
                            />
                        </div>
                    </div>
                    <div className="form__row">
                        <div className="form__col">
                            <Input
                                inputType="textArea"
                                label="Skilaboð"
                                name="message"
                                id="message"
                                value={values.message}
                            />
                        </div>
                    </div>
                    {(contactResponse === null)
                    ? null
                    : (
                        <div className="form__row">
                            <div className="form__col">
                                {(contactResponse instanceof Error)
                                ? <Alert type='error' headText={contactResponse.message} />
                                : <Alert type='info' headText={contactResponse} />}
                            </div>
                        </div>
                    )}
                </div>
                <div className="form__actions">
                    <Button type='submit' showLoader={loading} buttonType="primary" size="lg">Senda</Button>
                </div>
            </Form>
    }    
    return(
        <div className="KCL_notendur-form modal-form">
            <Formik
                initialValues={{
                    name: '',
                    email: '',
                    message: '',
                    // captcha: ''
                }}
                validationSchema={Yup.object({
                    name: Yup.string()
                        .required('Nafn má ekki vanta'),
                    email:  Yup.string()
                        .email('Ógilt netfang')
                        .required('Netfang verður að fylgja'),
                    message: Yup.string()
                        .required("Skilaboð má ekki vanta"),
                })}
                onSubmit={handleSubmit}
                component={form}
            />
        </div>
    )
}

export default DueDiligenceForm;